export default __webpack_public_path__ + "static/media/work2.a5bb4638.jpg";